import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { API_URL } from "../../../config";

const AssignDeviceModal = ({
  addDeviceModal,
  setAddDeviceModal,
  distributorId,
    setSuccessModal,
  setSuccessMessage,
  godevicelist
}) => {
  const [deviceQty, setDeviceQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleAssignDevice = async () => {
    setError("");

    // ✅ Validation
    if (!deviceQty) {
      return setError("Please enter device quantity");
    }

    if (isNaN(deviceQty) || Number(deviceQty) <= 0) {
      return setError("Enter valid positive number");
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");

      const res = await fetch(`${API_URL}/device-txn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          distributor_id: distributorId,
          available: Number(deviceQty),
        }),
      });

      const data = await res.json();

      if (!data.status) {
        throw new Error(data.message || "Something went wrong");
      }

      // ✅ Success
      setDeviceQty("");
      setAddDeviceModal(false);
      setSuccessMessage("Devices assigned successfully");
      godevicelist()
setSuccessModal(true);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={addDeviceModal}
      toggle={() => setAddDeviceModal(false)}
      className="connect-box"
      centered={true}
    >
      <ModalHeader toggle={() => setAddDeviceModal(false)}>
        <span className="ml-1 roititle text-white">Assign Devices</span>
      </ModalHeader>

      <ModalBody>
        <div className="modal-paragrph">
          <div className="col-lg-12">
            <div className="row">

              <div className="form-group col-lg-12 no-padding">
                <label className="control-label mb-0">
                  Number of devices*
                </label>

                <input
                  type="number"
                  value={deviceQty}
                  onChange={(e) => setDeviceQty(e.target.value)}
                  className="client-input"
                  placeholder="Enter device quantity"
                />

                {/* ❌ Error */}
                {error && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </div>
                )}
              </div>

            </div>

            <div className="py-1 text-center" style={{display:"flex",justifyContent:"center"}}>
              <button
                type="button"
                onClick={handleAssignDevice}
                className="btn-primary m-0"
                disabled={loading}
              >
                {loading ? "Assigning..." : "Assign"}
                {loading && <div id="loader"></div>}
              </button>
            </div>

          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssignDeviceModal;